<template>
  <v-layout
    row
    wrap
    grid-list-xxl
  >
    <v-flex
      sm12
      md6
      :order-sm2="right"
    >
      <v-img
        contain
        :src="media.url"
        :srcset="media.srcset"
        :style="{'background-color': lift.bg_color }"
      />
    </v-flex>
    <v-flex
      sm12
      md6
      class="story-content"
    >
      <base-description no-bottom-space>
        <LiftTitle :lift="lift"/>
        <LiftDescription no-bottom-space :lift="lift"/>
      </base-description>
      <LiftLinkBtn class="mt-4" :lift="lift"/>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import BaseDescription from '../../base/BaseDescription.vue'
import TranslationDisplay from '../../base/Translation/TranslationDisplay.vue'
import LiftLinkBtn from './LiftLinkBtn.vue'
import LiftTitle from './LiftTitle.vue'
import LiftDescription from './LiftDescription.vue'

export default Vue.extend({
  name: 'LiftPost',
  components: { LiftDescription, LiftTitle, LiftLinkBtn, TranslationDisplay, BaseDescription },
  props: {
    lift: {
      type: Object,
      required: true
    },
    right: Boolean
  },
  computed: {
    media () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return this.lift.mobile_media || {}
      }
      return this.lift.desktop_media || {}
    },
  }
})
</script>

<style
  lang="scss"
  scoped
>

.story-btn {
  margin-left: 0;
}
.story-content{
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

}

</style>